import React from 'react';

import DocTypeList from './DocTypeList';
import { SScrollableContainer, SSection, SWrapper } from '../styles/Selector.styled';

const DocTypeSelector: React.FC = () => {
  return (
    <SWrapper valueType="docType">
      <SSection>
        <SScrollableContainer>
          <DocTypeList />
        </SScrollableContainer>
      </SSection>
    </SWrapper>
  );
};

export default DocTypeSelector;
